var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dealer-info-page"},[_c('div',{staticClass:"back-wrapper"},[_c('router-link',{staticClass:"back",attrs:{"to":"/dealers"}},[_vm._v(" К списку производителей ")])],1),_c('DealerData')],1)}
var staticRenderFns = []

export { render, staticRenderFns }